import { ThemeOptions } from "@mui/material";

export const ecoPrimaryColor = '#2c72ab';
export const ecoSecondaryColor = '#FFA500';

export const DefaultTheme: ThemeOptions = {
    palette: {
        background: {
            default: "#fff"
        },
        primary: { main: ecoPrimaryColor, light: '#fff' },
        secondary: { main: ecoPrimaryColor, light: '#fff' },
        
    },
    components: {
        MuiTextField: { 
            defaultProps: {
                variant: 'standard'
            },
            styleOverrides: {
                root: {
                    borderColor: ecoPrimaryColor
                },
            }
        },
    }
};
